export const OperationalTypes = {
  IOperationalService: Symbol("IOperationalService"),
};
